import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UtilsService } from '@common/services';
import { OptionValue9 } from '@ui/components/form9/common';

import { PopupTooltipBaseComponent, PopupTooltipRef } from '@ui/misc/popup-tooltip';
import { DataWithGroupKey } from './data-with-group-key';

import { PopupDropdownParameters } from './popup-dropdown-parameters';

@Component({
    selector: 'aa-popup-dropdown',
    templateUrl: './popup-dropdown.component.html',
    styleUrls: [
        './popup-dropdown.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupDropdownComponent<T> extends PopupTooltipBaseComponent<PopupDropdownParameters<T>> implements OnInit, OnDestroy
{
    @Input() groupBy: (item: T) => OptionValue9;
    @Input() groupValue: (item: T) => OptionValue9;
    @Output() clickedItem: EventEmitter<T> = new EventEmitter<T>();
    public items: T[];
    public labelKey: keyof T;
    public data: DataWithGroupKey<T>[] = [];

    constructor (
        host: ElementRef<HTMLElement>,
        popupTooltipRef: PopupTooltipRef
    )
    {
        super(host, popupTooltipRef);
    }

    ngOnInit (): void
    {
        this.items = this.parameters.items;
        if (!UtilsService.isNullOrUndefined(this.groupBy))
        {
            Array.from(UtilsService.groupByTyped<OptionValue9, T>(this.parameters.items, this.groupBy))
                .forEach((group: [string, T[]]): void =>
                    group[1].forEach((value: T, idx: number): void =>
                    {
                        if (idx === 0)
                        {
                            this.data.push(new DataWithGroupKey(group[0]));
                        }

                        this.data.push(new DataWithGroupKey('', value));
                    })
                );
        }
        else
        {
            this.data = this.parameters.items.map((item: T) => new DataWithGroupKey('', item));
        }
    }

    public onSelectedItem (selectedItem: T): void
    {
        this.clickedItem.emit(selectedItem);
    }
}
